import { render } from "./TheContent.vue?vue&type=template&id=8f593120&scoped=true"
import script from "./TheContent.vue?vue&type=script&lang=js"
export * from "./TheContent.vue?vue&type=script&lang=js"

import "./TheContent.vue?vue&type=style&index=0&id=8f593120&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f593120"]])

export default __exports__